// Central API configuration
export const API_BASE_URL = 'https://aiviral-backend.onrender.com/api'
export const API_URL = API_BASE_URL
export const APP_URL = import.meta.env.VITE_APP_URL || 'https://ai-viral-studio.pages.dev'
